import { DatePeriodType } from './enums/date-period-type.enum';
import { AnalyzeCompareWith } from './enums/analyze-compare-with.enum';
import dayjs from 'dayjs';
import { AnalyzePaneSettings } from '@model';
import { DateIntervalType, AnalyzeEconomyDisplayType } from '@enums';
export class AnalyzeFilterSettings {
  monthDateFrom?: Date;
  monthDateTo?: Date;
  dayDateFrom?: Date;
  dayDateTo?: Date;
  hourDateFrom?: Date;
  hourDateTo?: Date;
  period: DatePeriodType;
  compareYears: number[];
  compareWith: AnalyzeCompareWith;
  normalYearAdjustment?: boolean;
  excludeWeekends?: boolean;
  effctSignatureLine?: boolean;
  displayPerMeteringPoint?: boolean;
  displayPerStatus?: boolean;
  displayCategoryEnergy?: boolean;
  displayCategoryEffect?: boolean;
  displayCategoryBonus?: boolean;
  displayCategoryServices?: boolean;
  displayCategoryOther?: boolean;
  displayCategorySpike?: boolean;
  explicitMeteringPointId: number;
  displaySupplyTemp: boolean;
  displayTempBonus: boolean;
  displayNormalAdjusted: boolean;
  markDateFrom: Date;
  markDateTo: Date;
  monthInterval: DateIntervalType;
  dayInterval: DateIntervalType;
  hourInterval: DateIntervalType;
  economyDisplayType: AnalyzeEconomyDisplayType;

  public static initialState = (): AnalyzeFilterSettings => {
    return <AnalyzeFilterSettings>{
      monthDateFrom: dayjs()
        .startOf('year')
        .toDate(),
      monthDateTo: dayjs()
        .endOf('year')
        .toDate(),
      period: DatePeriodType.Month,
      compareYears: [],
      compareWith: AnalyzeCompareWith.Nothing,
      normalYearAdjustment: false,
      displayPerMeteringPoint: false,
      displayPerStatus: false,
      displayCategoryEnergy: true,
      displayCategoryEffect: true,
      displayCategoryBonus: true,
      displayCategoryServices: true,
      displayCategoryOther: true,
      displayCategorySpike: true,
      explicitMeteringPointId: null,
      excludeWeekends: false,
      effctSignatureLine: false,
      displaySupplyTemp: false,
      displayTempBonus: false,
      displayNormalAdjusted: false,
      monthInterval: DateIntervalType.ThisYear,
      dayInterval: DateIntervalType.OneMonth,
      hourInterval: DateIntervalType.OneWeek,
      economyDisplayType: AnalyzeEconomyDisplayType.Sum
    };
  };

  public static mapFromSetting = (settings: AnalyzePaneSettings) => {
    return <AnalyzeFilterSettings>{
      monthDateFrom: settings.monthDateFrom,
      monthDateTo: settings.monthDateTo,
      dayDateFrom: settings.dayDateFrom,
      dayDateTo: settings.dayDateTo,
      hourDateFrom: settings.hourDateFrom,
      hourDateTo: settings.hourDateTo,
      period: settings.period,
      compareYears: settings.compareYears ? [...settings.compareYears] : [],
      compareWith: settings.compareWith,
      normalYearAdjustment: settings.normalYearAdjustment,
      excludeWeekends: settings.excludeWeekends,
      effctSignatureLine: settings.effctSignatureLine,
      displayPerMeteringPoint: settings.displayPerMeteringPoint,
      displayPerStatus: settings.displayPerStatus,
      displayCategoryEnergy: settings.displayCategoryEnergy,
      displayCategoryEffect: settings.displayCategoryEffect,
      displayCategoryBonus: settings.displayCategoryBonus,
      displayCategoryServices: settings.displayCategoryServices,
      displayCategoryOther: settings.displayCategoryOther,
      displayCategorySpike: settings.displayCategorySpike,
      explicitMeteringPointId: settings.explicitMeteringPointId,
      displaySupplyTemp: settings.displaySupplyTemp,
      displayTempBonus: settings.displayTempBonus,
      displayNormalAdjusted: settings.displayNormalAdjusted,
      markDateFrom: settings.markDateFrom,
      markDateTo: settings.markDateTo,
      monthInterval: settings.monthInterval,
      dayInterval: settings.dayInterval,
      hourInterval: settings.hourInterval,
      economyDisplayType: settings.economyDisplayType
    };
  };
}
